import { render, staticRenderFns } from "./HtmlTextarea.vue?vue&type=template&id=19b4c175&"
import script from "./HtmlTextarea.vue?vue&type=script&lang=js&"
export * from "./HtmlTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports